import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { IconsService } from '../../../../core/src/lib/services/icons.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
})
export class IconComponent implements OnInit, OnDestroy {
  private $unsubscribe = new Subject<void>();

  private _fill: string;
  private _stroke: string;
  private _iconMarkup: string;
  private _renderedIconElement: HTMLSpanElement;

  @Input()
  set fill(value: string) {
    this._fill = value;
    this._renderIcon();
  }

  get fill(): string {
    return this._fill;
  }

  @Input()
  set stroke(value: string) {
    this._stroke = value;
    this._renderIcon();
  }

  get stroke(): string {
    return this._stroke;
  }

  @Input()
  icon: string;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _elementRef: ElementRef,
    private iconsService: IconsService,
  ) {}

  private _svgElementFromString(str: string): HTMLSpanElement {
    const div = this.document.createElement('DIV');
    div.innerHTML = str as unknown as string;
    const svg = div.querySelector('svg') as SVGElement;

    // TODO: add an ngDevMode check
    if (!svg) {
      throw Error('<svg> tag not found');
    }

    this._applyPaintAttribute(svg, 'fill', this.fill);
    this._applyPaintAttribute(svg, 'stroke', this.stroke);

    const icon = this.document.createElement('span');
    icon.classList = 'app-icon-' + this.icon;
    icon.append(svg);
    return icon;
  }

  private _applyPaintAttribute(
    svg: SVGElement,
    attribute: 'fill' | 'stroke',
    value: string,
  ): void {
    if (!value) {
      return;
    }

    svg.setAttribute(attribute, value);

    svg.querySelectorAll(`[${attribute}]`).forEach((element) => {
      if (element.getAttribute(attribute) !== 'none') {
        element.setAttribute(attribute, value);
      }
    });
  }

  private _renderIcon(): void {
    if (!this._iconMarkup) {
      return;
    }

    const iconElement = this._svgElementFromString(this._iconMarkup);

    if (this._renderedIconElement) {
      this._renderedIconElement.replaceWith(iconElement);
    } else {
      this._elementRef.nativeElement.appendChild(iconElement);
    }

    this._renderedIconElement = iconElement;
  }

  ngOnInit() {
    this.iconsService
      .getIcon(this.icon)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((svgString: string) => {
        this._iconMarkup = svgString;
        this._renderIcon();
      });
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
